import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CashflowService } from '../../../../services/cashflow.service';

@Component({
  selector: 'app-cashflow-view',
  templateUrl: './cashflow-view.component.html',
  styleUrls: ['./cashflow-view.component.css']
})
export class CashflowViewComponent implements OnInit {
  entry: any = null;
  entryId?: number;
  loading = false;
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cashflowService: CashflowService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.entryId = +params['id'];
      this.loadEntry();
    });
  }

  loadEntry(): void {
    if (!this.entryId) {
      this.error = 'ID do lançamento não informado';
      return;
    }
    this.loading = true;
    this.error = null;
    this.cashflowService.getById(this.entryId).subscribe({
      next: (data) => {
        this.entry = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.message || 'Erro ao carregar o lançamento';
        this.loading = false;
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/financial/cashflow']);
  }

  goToEdit(): void {
    if (this.entryId) {
      this.router.navigate(['/financial/cashflow'], { queryParams: { editId: this.entryId } });
    }
  }

  formatDate(value: any): string {
    if (value == null || value === '') return '—';
    const d = typeof value === 'string' ? new Date(value.split('T')[0]) : new Date(value);
    return isNaN(d.getTime()) ? String(value) : d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  formatCurrency(value: number): string {
    if (value == null || value === undefined) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  getTypeBadgeClass(): string {
    const t = (this.entry?.type || '').toString().toLowerCase();
    return t === 'entrada' ? 'type-entrada' : 'type-saida';
  }

  getTypeLabel(): string {
    return (this.entry?.type || '').toString() || '—';
  }
}
